import Badge from './Badge';

export default Badge;
export { Badge };
export type { BadgeProps } from './type';
